<template>
    <div class="ui-page">
        <ui-page-header title="Procuradores" subtitle="Advogados cadastrados para representar credores nos casos.">
            <v-btn color="primary" outlined to="/procuradores/procuracao-modelo">
                <v-icon left small>mdi-file-sign</v-icon>
                Procuração modelo
            </v-btn>
            <v-btn color="primary" outlined @click="load(true)">
                <v-icon left small>mdi-microsoft-excel</v-icon>
                Exportar
            </v-btn>
            <v-btn v-if="$allowed('create')" id="btnNew" color="primary" depressed to="/procuradores/novo">
                <v-icon left small>mdi-plus</v-icon>
                Incluir
            </v-btn>
        </ui-page-header>

        <pending-procurator-associations @updated="load" />

        <ui-table-card clearable :can-clear="hasFilters" @clear="clearFilters">
            <template #toolbar>
                <v-text-field id="name" v-model="dataList.filter.name" placeholder="Buscar pelo nome" prepend-inner-icon="mdi-magnify"
                    dense outlined hide-details class="ui-toolbar__search" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-text-field id="oab" v-model="dataList.filter.oab" placeholder="Carteira OAB" dense outlined hide-details
                    class="ui-toolbar__field" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-select v-model="dataList.filter.verified" :items="dataset.verifiedOptions" item-value="id" item-text="name"
                    placeholder="Verificado" dense outlined hide-details class="ui-toolbar__field"
                    :menu-props="{ offsetY: true }" @change="applyFilters"></v-select>
                <!-- <v-text-field dense id="code" label="OAB UF" v-model="dataList.filter.federal_registration_uf" hide-details
                    outlined></v-text-field> -->
            </template>

            <v-data-table :headers="dataList.headers" :items="dataList.data" :server-items-length="dataList.count"
                :options.sync="dataList.options" :loading="dataList.loading" disable-sort hide-default-footer
                no-data-text="Nenhum procurador foi encontrado" loading-text="Carregando dados..." class="ui-clickable-rows"
                @click:row="openRow">

                <template v-slot:[`item.created_at`]="{ item }">
                    {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm") }}
                </template>

                <template v-slot:[`item.name`]="{ item }">
                    <div class="ui-cell-main">{{ item.name && item.name ? item.name : 'N/A' }}</div>
                    <div class="ui-cell-sub">{{ item.email }}</div>
                </template>

                <template v-slot:[`item.oab`]="{ item }">
                    {{ item.oab || 'Não informada' }}
                </template>

                <template v-slot:[`item.oab_state`]="{ item }">
                    {{ item.oab_state || 'Não informada' }}
                </template>

                <!-- Validacao interna do cadastro, como no credor: sem verificacao o procurador nao consegue entrar -->
                <template v-slot:[`item.account_verified_at`]="{ item }">
                    <ui-badge :text="isVerified(item) ? 'SIM' : 'NÃO'" :color="isVerified(item) ? 'accent' : 'warning'" />
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <ui-row-actions :actions="[
                        { text: 'Validar cadastro internamente', icon: 'mdi-account-check-outline', hidden: isVerified(item), disabled: !$check('Procurator', 'PATCH') || verifyingId === item.id, handler: () => verifyItem(item) },
                        { text: 'Editar', icon: 'mdi-pencil-outline', disabled: !$check('Procurator', 'PATCH'), handler: () => viewItem(item) },
                        { text: 'Excluir', icon: 'mdi-delete-outline', danger: true, disabled: !$check('Procurator', 'DELETE'), handler: () => deleteItem(item) },
                    ]" />
                </template>
            </v-data-table>

            <template #footer>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.itemsPerPage || 10"
                    :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </template>
        </ui-table-card>
    </div>
</template>

<script>
import { downloadXlsx } from "@/common/util/export-xlsx.util";

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';
//import incidentResultStatus from "@/common/data/incident-result-status.data"
//import incidentResultStatusFilter from "@/common/data/incident-result-status.data"
import pretensionTypes from "@/common/data/incident-pretension-types.data"
import PendingProcuratorAssociations from "@/components/PendingProcuratorAssociations.vue"

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "IncidentList",

    components: {
        PendingProcuratorAssociations,
    },

    data: () => ({
        verifyingId: null,
        dataset: {
            verifiedOptions: [
                { id: "", name: "Todos" },
                { id: "pending", name: "Não" },
                { id: "verified", name: "Sim" },
            ],
            data: {},
            clients: [],
        },
        pretensionTypes: pretensionTypes,
        dataList: {
            filter: {
                verified: "",
                name: "",
                registration: "",
                client: "",
                code: "",
                status: "",
                oab: "",

            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "OAB", value: "oab" },
                { text: "UF da OAB", value: "oab_state" },
                { text: "Verificado", value: "account_verified_at" },
                { text: "Criado em", value: "created_at" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    computed: {
        hasFilters() {
            return Object.values(this.dataList.filter).some((value) => value);
        },
    },

    created() {
        this.load();
    },

    methods: {

        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        filterDebounced: _.debounce(function () {
            this.applyFilters();
        }, 400),

        clearFilters() {
            this.dataList.filter = { verified: "", name: "", registration: "", client: "", code: "", status: "", oab: "" };
            this.applyFilters();
        },

        // A troca de tamanho e seguida de update:page(1), que recarrega.
        setPageSize(size) {
            this.dataList.options.itemsPerPage = size;
        },

        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.size = size;
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },


        async load(exportCsv) {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v || v === 0))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = exportCsv ? 1000000 : (this.dataList.options.itemsPerPage || 10);

            var start = (exportCsv !== undefined && exportCsv) ? 1 : this.dataList.options.page;

            try {
                const result = await axios.get('/api/admin/procurators', { params: { page: start, limit: limit, search: search } });

                if(!exportCsv) {
                    this.dataList.data = result.data.content.data;
                    this.dataList.count = result.data.content.paging.total;
                    
                    return;
                }

                this.generateCSV(result.data.content.data)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },


        isVerified(item) {
            const value = item && item.account_verified_at;
            return !!value && value !== '0000-00-00 00:00:00';
        },

        async verifyItem(item) {
            const proceed = await this.$dialog.confirm({
                title: 'Validar cadastro',
                text: `Validar internamente o cadastro do procurador "${item.name}"? Ele passará a conseguir acessar o site sem confirmar o e-mail.`,
                actions: { false: 'Cancelar', true: 'Validar' },
            });
            if (!proceed) return;

            this.verifyingId = item.id;
            try {
                await axios.post(`/api/admin/users/verify-account/${item.id}`, {});
                this.$dialog.notify.info('Cadastro validado com sucesso.', { position: 'top-right', timeout: 2000 });
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 3000 });
            } finally {
                this.verifyingId = null;
            }
        },

        // A linha abre o detalhe so com a mesma permissao do "Editar".

        openRow(item) {

            if (this.$check('Procurator', 'GET')) this.viewItem(item);

        },


        viewItem(item) {
            this.$router.push(`procuradores/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir Procurador',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                await axios.delete(`/api/admin/procurators/${item.id}`)

                this.$dialog.notify.info("Procurador excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },

        getFormattedDate() {
            const currentDate = new Date();
            const day = String(currentDate.getDate()).padStart(2, '0'); 
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = currentDate.getFullYear(); 

            return `${day}-${month}-${year}`;
        },

        async generateCSV(data) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja exportar os dados para Excel?',
                title: 'Exportar dados',
                actions: {
                    false: 'Cancelar',
                    true: 'Exportar'
                }
            })

            if (!proceedAction) return;

            if (data.length == 0) {
                this.$dialog.notify.error("Sem dados para exportar!", { position: "top-right", timeout: 3000 });

                return;
            }

            const formattedDate = this.getFormattedDate();

            const newData = data.map(objeto => ({
                "NOME PROCURADOR": objeto.name,
                "EMAIL": objeto.email,
                "OAB": objeto.oab,
                "ESTADO OAB": objeto.oab_state,
                "CRIADO EM": objeto.created_at,

            }));

            try{

                await downloadXlsx(newData, 'procuradores-' + formattedDate, { sheetName: 'Procuradores' });

                this.$dialog.notify.info("Planilha Excel gerada com sucesso!", { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },
    },
};
</script>
